import Vue from 'vue';

let modalVm;
const modalId = 'argus-api-error-modal';
let active = false;
let suppressed = false;

function getModalVm() {
    if (!modalVm) modalVm = new Vue();
    return modalVm;
}

export function setApiErrorDialogSuppressed(value) {
    suppressed = Boolean(value);
    if (suppressed) dismissApiErrorDialog();
}

export function dismissApiErrorDialog() {
    if (active) getModalVm().$bvModal.hide(modalId);
}

export function showApiErrorDialog(message) {
    if (active || suppressed) return;
    active = true;
    Promise.resolve(getModalVm().$bvModal.msgBoxOk(message, {
        id: modalId,
        title: 'Не удалось выполнить запрос',
        okTitle: 'Понятно',
        okVariant: 'primary',
        contentClass: 'argus-glass-dialog',
    })).catch(() => {}).finally(() => { active = false; });
}
